
import { Component, Prop, Vue } from "vue-property-decorator";
import errGif from "@/assets/401-images/401.gif";

@Component({})
export default class extends Vue {
    @Prop({}) private value!: any;
    @Prop({ default: true }) private operate!: boolean;
    @Prop({ default: "40%" }) private width!: boolean;
    @Prop({ default: 1 }) private format!: Number;

    private errGif = errGif + "?" + new Date();

    private resetVal() {
        this.$emit("change");
    }
}
